// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".registry-to-istio-form-registry-to-istio-form-0b649 .ant-form-item-control{margin-left:16px!important}.registry-to-istio-form-registry-to-istio-form-0b649 .ant-form-item-control .ant-form-item-control-input{width:277px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"registry-to-istio-form": "registry-to-istio-form-registry-to-istio-form-0b649",
	"registryToIstioForm": "registry-to-istio-form-registry-to-istio-form-0b649"
};
export default ___CSS_LOADER_EXPORT___;
